'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReactMotionLoop = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactMotion = require('react-motion');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var ReactMotionLoop = exports.ReactMotionLoop = _react2.default.createClass({
  displayName: 'ReactMotionLoop',

  propTypes: {
    styleFrom: _react2.default.PropTypes.object.isRequired,
    styleTo: _react2.default.PropTypes.object.isRequired
  },

  getInitialState: function getInitialState() {
    return { flag: true };
  },
  componentWillUnmount: function componentWillUnmount() {
    cancelAnimationFrame(this.raf);
  },
  onRest: function onRest() {
    var _this = this;

    this.raf = requestAnimationFrame(function () {
      return _this.setState({ flag: !_this.state.flag });
    });
  },
  render: function render() {
    var _props = this.props;
    var styleFrom = _props.styleFrom;
    var styleTo = _props.styleTo;

    var props = _objectWithoutProperties(_props, ['styleFrom', 'styleTo']);

    var flag = this.state.flag;

    var defaultStyle = Object.keys(styleFrom).reduce(function (result, key) {
      return _extends({}, result, _defineProperty({}, key, _typeof(styleFrom[key]) === 'object' ? styleFrom[key].val : styleFrom[key]));
    }, {});
    var style = flag ? styleTo : styleFrom;

    return _react2.default.createElement(_reactMotion.Motion, _extends({
      defaultStyle: defaultStyle,
      onRest: this.onRest,
      style: style
    }, props));
  }
});
//# sourceMappingURL=Component.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-motion-loop/lib/Component.js
// module id = 350
// module chunks = 0